import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import { filterMenuItems } from '../../utils/menuAccess';
import './ReportsPage.css';

const reportItems = [
  { label: 'Rapport général',               icon: '📈', path: '/rapports/general' },
  { label: 'Liste des ventes',              icon: '📋', path: '/rapports/liste-ventes' },
  { label: 'Numeros gagnants',              icon: '🔄', path: '/rapports/winning-numbers' },
  { label: 'Tickets Gagnant',                icon: '🎫', path: '/rapports/winning-tickets' },
  { label: 'Resume accumule',                icon: '📊', path: '/rapports/accumulated-summary' },
  { label: 'Cumul detaille',                 icon: '📊', path: '/rapports/cumul-detaille' },
  { label: 'Tickets Vendus',                 icon: '🎫', path: '/rapports/tickets-vendus' },
  { label: 'Tickets Annulaient',             icon: '🚫', path: '/rapports/tickets-annulaient' },
  { label: 'Resume de la Banque-Lottery',    icon: '🏦', path: '/rapports/resume-banque-lottery' },
  { label: 'Paris gagnants',                 icon: '🔄', path: '/rapports/paris-gagnants' },
  { label: 'Rapport du Terminal',            icon: '🖥️', path: '/rapports/terminal-report' },
  { label: 'Rapport du Banque',              icon: '🏦', path: '/rapports/banques-rapport' },
  // { label: "Rapport d'activite",             icon: '📋', path: null },
  // { label: 'Reporte de Grupos',              icon: '👤', path: null },
  // { label: 'Resultats par loterie',          icon: '🔄', path: null },
];

const ReportsPage = () => {
  const { company } = useAuth();
  const visibleItems = useMemo(
    () => filterMenuItems(reportItems, company?.menu_keys),
    [company?.menu_keys],
  );

  return (
    <Layout>
      <p className="rp-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/rapports" className="bc-link">Reports</Link>
      </p>

      <div className="rp-grid">
        {visibleItems.map((item) => (item.path ? (
          <Link key={item.label} to={item.path} className="rp-item">
            <div className="rp-icon">{item.icon}</div>
            <span className="rp-label">{item.label}</span>
          </Link>
        ) : (
          <div key={item.label} className="rp-item">
            <div className="rp-icon">{item.icon}</div>
            <span className="rp-label rp-label-disabled">{item.label}</span>
          </div>
        )))}
      </div>
    </Layout>
  );
};

export default ReportsPage;
